import { ItemCategory } from "../types";

/**
 * Catalog brands by category — sell BrandSelector is select-only from this list.
 * Keep names buyer-facing (canonical spelling). Empty arrays = no brand field
 * expected for that category (fieldConfigs.brand should be false).
 */
export const brandSuggestionsByCategory: Record<ItemCategory, string[]> = {
  electronics: [
    "LG",
    "Samsung",
    "Sony",
    "Panasonic",
    "TCL",
    "Hisense",
    "Sharp",
    "Toshiba",
    "Philips",
    "Haier Thermocool",
    "Scanfrost",
    "Midea",
    "Nexus",
    "Skyrun",
    "Polystar",
    "Bruhm",
    "Royal",
    "Nasco",
    "Maxi",
    "Century",
    "Daikin",
    "Carrier",
    "Xiaomi",
    "Binatone",
  ],
  power_solutions: [
    "Firman",
    "Honda",
    "Elepaq",
    "Lutian",
    "Sumec",
    "Yamaha",
    "Mikano",
    "Thermocool",
    "Haier Thermocool",
    "Luminous",
    "Su-Kam",
    "Mercury",
    "Felicity",
    "Nexus",
    "Maxi",
    "Century",
  ],
  kitchen: [
    "Haier Thermocool",
    "LG",
    "Samsung",
    "Scanfrost",
    "Midea",
    "Sharp",
    "Hisense",
    "Binatone",
    "Nexus",
    "Skyrun",
    "Polystar",
    "Bruhm",
    "Nasco",
    "Maxi",
    "Philips",
    "Kenwood",
    "Moulinex",
    "Black+Decker",
    "Russell Hobbs",
    "Nutribullet",
    "Bosch",
    "Whirlpool",
  ],
  furniture: [
    "Ikea",
    "Vitafoam",
    "Mouka",
    "Vono",
    "Kraftmatic",
    "Duroflex",
    "Godrej",
  ],
  bedding: [
    "Mouka",
    "Vitafoam",
    "Vono",
    "Duroflex",
    "Kraftmatic",
    "Dunlopillo",
  ],
  fitness: [
    "ProForm",
    "NordicTrack",
    "Bowflex",
    "Sole",
    "Schwinn",
    "Raleigh",
    "Trek",
    "Giant",
  ],
  fashion: ["Singer", "Brother", "Janome", "Bernina", "Pfaff", "Elna"],
  decor: [],
  outdoor: [],
  tools: ["Bosch", "Black+Decker", "Stanley", "Makita", "DeWalt", "Ryobi"],
  lighting: ["Philips", "Osram", "GE", "Sylvania", "Cree"],
  baby: ["Graco", "Fisher-Price", "Chicco", "Evenflo", "Safety 1st", "Stokke"],
  digital_wears: ["Apple", "Samsung", "Garmin", "Fitbit", "Xiaomi", "Amazfit"],
  gaming: ["PlayStation", "Xbox", "Nintendo", "Sega", "Steam"],
  personal_computers: [
    "HP",
    "Dell",
    "Lenovo",
    "Apple",
    "Asus",
    "Acer",
    "Microsoft",
  ],
  phones_tabs: [
    "Apple",
    "Samsung",
    "Tecno",
    "Infinix",
    "Xiaomi",
    "Oppo",
    "Vivo",
    "Itel",
    "Nokia",
    "Google",
    "OnePlus",
    "Redmi",
  ],
  other: [],
};

/**
 * Get brand catalog for a category (deduped, stable order).
 */
export function getBrandSuggestions(
  category: ItemCategory | string | null | undefined,
): string[] {
  if (!category) return [];
  const list = brandSuggestionsByCategory[category as ItemCategory] || [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const brand of list) {
    const key = brand.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(brand);
  }
  return out;
}

/**
 * Filter brand catalog by search term (does not invent custom brands).
 */
export function searchBrands(
  searchTerm: string,
  category: ItemCategory | string | null | undefined,
): string[] {
  const suggestions = getBrandSuggestions(category);
  if (!searchTerm.trim()) return suggestions.slice(0, 12);

  const normalizedSearch = searchTerm.toLowerCase();
  return suggestions
    .filter((brand) => brand.toLowerCase().includes(normalizedSearch))
    .slice(0, 12);
}
